import { Typography } from 'antd';
import styled from 'styled-components';
const {
  Title
} = Typography;
export const TabTitle = styled(Title)`
  text-align: center;
  width: 100%;
  background-color: #ffffff;
  margin-top: 14px;
  color: #98a9bc;
  font-weight: bold;
`;